// Admin session handling in the main app. Sign-in happens on the standalone
// /admin page (nothing admin-related is visible to signed-out visitors);
// credentials live in sessionStorage and are attached to /api/admin/* calls.
import { api, clearAdminAuth, getAdminAuth } from './api';
import { $ } from './dom';
import { state } from './state';
import { toast } from './toast';

export function initAdmin(): void {
  $('#btnLogout').addEventListener('click', () => {
    clearAdminAuth();
    setAdmin(false);
    toast('Signed out');
  });
  state.addEventListener('admin', applyVisibility);
  applyVisibility();
}

/** Restore a session started on /admin (same tab) before the first payload load. */
export async function restoreAdminSession(): Promise<void> {
  if (!getAdminAuth()) return;
  try {
    await api.admin.ping();
    setAdmin(true);
  } catch {
    clearAdminAuth();
  }
}

function setAdmin(on: boolean): void {
  if (state.admin === on) return;
  state.admin = on;
  state.emit('admin');
}

function applyVisibility(): void {
  document.body.classList.toggle('is-admin', state.admin);
  document.querySelectorAll<HTMLElement>('.admin-only').forEach((node) => {
    node.hidden = !state.admin;
  });
  $<HTMLElement>('#btnLogout').hidden = !state.admin;
}
